export default __webpack_public_path__ + "static/media/finger_positions_1289.621f4841.jpeg";